/**
 * SEARCH-002 §8.5 — Détection d'intention (helpers PURS, ADDITIFS).
 *
 * Ne masque JAMAIS un résultat d'entité (un client « Formation 2024 SARL »
 * reste affiché même si la requête « ressemble » à une question). Ces helpers
 * ne font que PROMOUVOIR la ligne passerelle pertinente et router la touche
 * Entrée (§8.4). Testables sans rendu.
 */

const QUESTION_WORDS = [
    // FR
    'comment', 'pourquoi', 'où', 'ou', 'quand', 'qui', 'quel', 'quelle',
    'quels', 'quelles', 'combien', 'est-ce',
    // EN
    'how', 'why', 'where', 'when', 'who', 'what', 'which', 'can', 'do', 'does',
]

/** Tout-chiffres ≥ 6 → promeut tél / SIREN / SIRET (entité, pas aide). */
export function isAllDigits(q: string): boolean {
    const digits = q.replace(/\D/g, '')
    return digits.length >= 6 && digits.length >= q.trim().replace(/\s/g, '').length
}

/** « ? » final, > ~5 mots, ou mot interrogatif initial → promeut l'assistant. */
export function isLikelyQuestion(q: string): boolean {
    const trimmed = q.trim()
    if (!trimmed) return false
    if (trimmed.endsWith('?')) return true
    const words = trimmed.split(/\s+/)
    if (words.length > 5) return true
    const first = words[0]?.toLowerCase().replace(/[?!.,]/g, '') ?? ''
    return QUESTION_WORDS.includes(first)
}

export type SearchIntent = 'entity' | 'help' | 'assistant'

/**
 * Classe l'intention pour le routage de la touche Entrée (§8.4) :
 *  - une entité a le focus → 'entity' (ne jamais détourner une recherche réussie) ;
 *  - question → 'assistant' ;
 *  - sinon → 'help' (déterministe).
 */
export function classifyIntent(
    q: string,
    hasEntityHits: boolean,
    assistantEnabled: boolean,
): SearchIntent {
    if (hasEntityHits) return 'entity'
    if (assistantEnabled && isLikelyQuestion(q)) return 'assistant'
    return 'help'
}
